import React, { useContext, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { BoletimContext } from "../context/BoletimContext";
import { Context as AuthContext } from "../context/AuthContext";

const labels = {
  synced: "Salvo no servidor",
  syncing: "Sincronizando boletim...",
  "saved-local": "Salvo neste dispositivo; aguardando sincronização",
  pending: "Alterações aguardando sincronização",
  waiting: "Backend indisponível; dados pendentes neste dispositivo",
  error: "Erro de sincronização",
  conflict: "Conflito de versões: compare antes de continuar",
  "auth-required": "Entre novamente para sincronizar os rascunhos",
  disabled: "Rascunho offline desabilitado neste build",
};

export default function BoletimSyncStatus() {
  const { syncStatus, pendingCount, offlineDraftsEnabled, boletim } = useContext(BoletimContext);
  const { offlineMode, authenticated } = useContext(AuthContext);
  const [networkOffline, setNetworkOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const onOnline = () => setNetworkOffline(false);
    const onOffline = () => setNetworkOffline(true);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);
  if (!authenticated || (syncStatus.state === "idle" && !offlineMode && !networkOffline)) return null;

  const idleMessage = offlineMode
    ? "Modo offline; somente rascunhos locais estão disponíveis."
    : "Sem conexão de rede; o backend será verificado na próxima tentativa.";
  const mode = offlineMode ? " (sessão local válida até expirar)" : "";
  const message = `${syncStatus.state === "idle" ? idleMessage : labels[syncStatus.state] || "Estado do rascunho indisponível"}${mode}${pendingCount ? ` · ${pendingCount} pendente(s)` : ""}${syncStatus.message ? ` — ${syncStatus.message}` : ""}`;
  const variant = ["error", "conflict", "auth-required", "disabled"].includes(syncStatus.state)
    ? "warning"
    : networkOffline || offlineMode || syncStatus.state === "idle" || syncStatus.state === "waiting" || syncStatus.state === "pending" || syncStatus.state === "saved-local"
      ? "info"
      : "success";

  return (
    <Alert
      variant={variant}
      className="bo-sync-status py-2 px-3 mb-2"
      role={syncStatus.state === "error" || syncStatus.state === "conflict" ? "alert" : "status"}
      aria-live="polite"
    >
      <strong>{message}</strong>
      {boletim?._adminEditing && <span className="d-block small">Edição administrativa: salve explicitamente na revisão do boletim. As alterações exigem conexão, confirmação e justificativa; não são enviadas automaticamente.</span>}
      {!offlineDraftsEnabled && syncStatus.state === "disabled" && (
        <span className="d-block small">As alterações só podem ser confirmadas enquanto o servidor estiver acessível.</span>
      )}
    </Alert>
  );
}
